import { IconBookmark, IconBuildings, IconCoil, IconEnergyCircle, IconRuler, IconShare, IconSignal, IconTools } from '@assets/images/icon';
import { bell1 } from '@assets/images/main/iot/product';
import { airQuality1, coMeasure1, sensorThumb } from '@assets/images/main/sensor';

export default {
  a: [
    { text: '主要用途', icon: IconCoil },
    { text: '测量项目', icon: IconRuler },
    { text: '通信频段', icon: IconSignal },
    { text: '安装环境', icon: IconEnergyCircle },
    { text: '供电方式', icon: IconTools },
    { text: '功能摘要', icon: IconBuildings },
    { text: '是否支持 ORBRO 联动', icon: IconBookmark },
    { text: '外部联动', icon: IconShare },
  ],

  b: [
    { text: '工业设备状态检测' },
    { text: '温度、湿度、漏水、压力、振动、接点等' },
    { text: 'LoRa、RS-485' },
    { text: '建筑工地、工厂、物流仓库等' },
    { text: '电池 / DC 电源' },
    { text: '支持多种传感器输入，支持最长 6 公里 LoRa 无线通信' },
    { text: '支持' },
    { text: '提供 API' },
  ],

  c: [
    { text: 'CO₂泄漏检测与报警' },
    { text: '一氧化碳、温度' },
    { text: 'Wi-Fi、RS-485' },
    { text: '密闭空间、污水处理厂、废弃物处理设施等' },
    { text: '电池 / DC 电源' },
    { text: '专用于有害环境的 CO₂ 传感器，适用于敏感和高危区域' },
    { text: '支持' },
    { text: '提供 API' },
  ],

  d: [
    { text: '室内空气质量监测' },
    { text: 'PM2.5、CO₂、TVOC、温湿度' },
    { text: 'Wi-Fi、RS-485' },
    { text: '医院、办公室、公共场所等室内环境' },
    { text: 'DC 24V' },
    { text: '高精度空气质量分析，获得环境部门认证' },
    { text: '支持' },
    { text: '提供 API' },
  ],

  e: [
    { text: '紧急事件通知' },
    { text: '紧急按钮状态' },
    { text: 'Bluetooth 5、Wi-Fi' },
    { text: '医院、仓库、办公室、现场走廊等' },
    { text: 'AAA 电池' },
    { text: '短信发送、Wi-Fi 联动、低功耗运行' },
    { text: '支持' },
    { text: '提供 API' },
  ],

  spec: [
    {},

    {
      image: sensorThumb,
      link: '/cn/iot/LoRASensor',
      title: 'LoRa 传感器',
      desc: '新',
    },
    {
      image: coMeasure1,
      link: '/cn/iot/co2',
      title: 'CO₂ 测量仪',
      desc: '新',
    },
    {
      image: airQuality1,
      link: '/cn/iot/air',
      title: '空气质量监测仪',
      desc: '新',
    },
    {
      image: bell1,
      link: '/cn/iot/bell',
      title: '紧急呼叫按钮',
      desc: '',
    },
  ],
};
